import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom'; 
import { baseurl } from '../utility/helper';

const AdminDashboard = ({ adminId }) => {
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate(); 

  const fetchAdminData = () => {
    const token = sessionStorage.getItem("token");
    setLoading(true);
    axios.get(`${baseurl}/admin/dashboard`, {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    })
    .then(response => {
      setFormData(response.data);
      setLoading(false);
    })
    .catch(error => {
      console.error('Error fetching admin data:', error);
      setError('Failed to fetch admin data');
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchAdminData();
  }, [adminId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  //  Handle card click
  const handleCardClick = (chapterId) => {
    navigate(`/admin/MemberList/${chapterId}`); //  Navigate with chapterId in path
  };

  return (
    <div className="content container-fluid">
      <div className="row">
        {formData.map(admin => (
          <div
            key={admin.id}
            className="col-xl-3 col-sm-6 col-12"
            style={{ cursor: 'pointer' }}
            onClick={() => handleCardClick(admin.chapter_id)} //  trigger onClick
          >
            <div className="card mb-4">
              <div className="card-body">
                <div className="dash-widget-header">
                  <span className="dash-widget-icon bg-2">
                    <img src="/assets/img/mensatrans2.png" class="img-fluid2 logo-blue" alt="Logo" />
                  </span>
                  <div className="dash-count">
                    <div className="dash-title"><b>{admin.chapter_name}</b></div>
                    <div className="dash-title2"><b>Chapter</b></div>
                    <div className="dash-counts">
                      <h4 style={{ fontWeight: "bold", paddingTop: "5px" }}>{admin.total_members}</h4>
                    </div>
                  </div>
                </div>
                <div className="progress progress-sm mt-3">
                  <div className="progress-bar bg-6" role="progressbar" style={{ width: '100%' }} aria-valuenow="75"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
